import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

import FavoritedOrders from "./FavoritedOrders";

class Principles extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    if (this.props.authUser.uid) return <FavoritedOrders uid={this.props.authUser.uid} />
    return <p>Loading...</p>;
  }
}

const mapStateToProps = (state) => {
  return {
    authUser: state.auth.user,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Principles);


// WEBPACK FOOTER //
// ./src/views/Dispatch/FavOrderParent.jsx